/*eslint @typescript-eslint/no-unused-vars: "off"*/
import React, { useState, useContext, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import TextField from "@material-ui/core/TextField";
import clsx from "clsx";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import { styled } from "@mui/material/styles";
import {
  Checkbox,
  Divider,
  FormControlLabel,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

// import palette from "../../theme/palette";
// import ProgressStepper from "./progressStepper";
import ModalCloseIcon from "../../../assets/images/icon/modalCloseIconBlack";
import { ContactsDataJson as contacts, ReviewData } from "./contactsData";
import AddContactModal from "./AddContactModal";
import ManageContactModal from "./ManageContactModal";
import { ContactsContext } from "../../../context/userIContacts";
import { contactsService } from "../../../services/contactsService";
import { UserTypeContext } from "../../../context/userStatus";
import SnackBarComp, { SnackBarCompV2 } from "../../../components/snackBar";
import moment from "moment";
import { xVersion } from "../../../services/config";
import palette from "../../../theme/palette";
import SocialReportStepper from "./SocialReportStepper";
import { pxToRem } from "../../../theme/typography";
import {
  InfluenceGetList,
  InfluenceGetResponse,
  OutcomeGetList,
  OutcomeGetResponse,
  RefelectiveGetResponse,
} from "../../../interfaces/outcomeModal";
import SocialReportSchedules from "./SocialReportSchedules";
import { setSelectedRow, setSelectedRowDetails } from "../../../store/actions/reportTypeAction";
import { ReportsTypeContext } from "../../../context/userIReports";
import ModalCloseIconBlack from "../../../assets/images/icon/modalCloseIconBlack";
import CommonTypo from "../../../components/CommonTypo";
import CloseButton from "../../../components/CloseButton";
import SocialReportShareStep1 from "./SocialReportSteps";
import SocialReportShareStep1Content from "./SocialReportStepsSideContent";
import SocialScheduleReport from "./SocialScheduleReport";
import SocialReportStepsSidePreview from "./SocialReportStepsSidePreview";
import { TrackingContext } from "../../../context/userTracking";
import { addCategoryExpandAction, addCategoryJourneyAction, addInfluenceAction, addJourneyAction, addNotesAction, addNotesJourneyAction, addOutcomeAction, addRefelectiveAction, isEmptyState } from "../../../store/actions/userTypeAction";
import { trackingService } from "../../../services/tracking";
import { setInfluenceIdeas, setOutcomeIdeas, setReflectiveIdeas, setTrackingState } from "../../../store/actions/trackerAction";
import { outcomeService } from "../../../services/outcome";
import { reflectiveQueService } from "../../../services/reflective-questions";
import { influenceService } from "../../../services/influence";
// import { trackingService } from "../../services/tracking";
// import { UserTypeContext } from "../../context/userStatus";
// import { ButtonLoader } from "../../components/buttonLoader";
// import OutcomeclosePopup from "./OutcomeclosePopup";
// import DeleteIcon from "../../assets/images/icon/DeleteIcon";
// import { addCategoryJourneyAction, addJourneyAction } from "../../store/actions/userTypeAction";
const CustomCheckBox = styled(Checkbox)(({ theme }) => ({
  color: "#DCE6E0",
  borderRadius: "4px",

  "&.Mui-checked": {
    color: "var(--color-new-main)",
    borderRadius: "4px",
  },
}));
const CustomRadio = styled(Radio)(({ theme }) => ({
  color: "#DCE6E0",
  borderRadius: "4px",

  "&.Mui-checked": {
    color: "#11734A",
    borderRadius: "4px",
  },
}));
const useStyles = makeStyles((theme) => ({
  contactButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "10px",
    gap: "10px",

    height: "36px",

    /* BackgroundColors/PureWhite */

    background: "var(--white-background)",
    /* BackgroundColors/GhostButtonBorder */

    border: "1.5px solid rgba(17, 115, 74, 0.4)",
    borderRadius: "6px",
    marginBottom: "10px !important",
    margin: "10px 5px !important",
    color: "#3E4240 !important",
    fontWeight: 400,
    fontSize: "16px!important",
    lineHeight: "100%!important",
  },
  radioOptionDiv: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  radioOptionDivText: {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "100%",
    /* identical to box height, or 16px */

    display: "flex",
    flexDirection: "row",
    alignItems: "center",

    /* TextColors/DarkGrey */

    color: "#3E4240 !important",
  },
  raioOptionInputs: {
    height: "48px",

    /* BackgroundColors/GreenyAreaBG */

    /* BackgroundColors/Dividers */

    border: "1px solid #DCE6E0",
    borderRadius: "8px",
    padding: "0 4px",
    "& .MuiOutlinedInput-root": {
      margin: "auto",
      "& input": {
        padding: "2px !important",
      },
    },
  },
  raioOptionSelect: {
    height: "48px",

    /* BackgroundColors/GreenyAreaBG */

    /* BackgroundColors/Dividers */

    border: "1px solid #DCE6E0",
    borderRadius: "8px",
    padding: "0 4px",
    "& .MuiOutlinedInput-root": {
      margin: "auto 5px",
      display: "flex",
      alignItems: "center",
      "& .MuiInputBase-input": {
        padding: "2px !important",
      },
    },
  },
  reviewTitle: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "100%",
    /* identical to box height, or 16px */

    display: "flex",
    alignItems: "center",

    /* TextColors/DarkGrey */

    color: "#3E4240",
    margin: "4px 0",
  },
  reviewDescriptionV2: {
    padding: "8px 24px 8px 24px",
    gap: "4px",
    borderRadius: "20px",
    display: "flex",
    flexWrap: "nowrap",
    whiteSpace: "nowrap",
    border: "1px solid #EEEEEE",
  },
  reviewDescription: {
    fontWeight: 400,
    fontSize: "16px",
    // lineHeight: '100%',
    /* identical to box height, or 16px */

    // display: 'flex',
    // alignItems: 'center',

    /* TextColors/DarkGrey */

    color: "#3E4240",
    margin: "4px 0",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    lineClamp: 2,
    display: "-webkit-box",
    boxOrient: "vertical",
    // fontStyle: 'normal',
    // fontWeight: 500,
    // fontSize: '16px',
    // color: '#3E4240',
    // overflow: 'hidden',
    // display: '-webkit-box',
    // lineClamp: 2,
    // boxOrient: 'vertical',
  },
  treeClass: {
    display: "flex",
    flexDirection: "column",
    alignSelf: "stretch",
    gap: "16px",
    overflowY: "auto",
    "& .MuiTreeItem-content": {
      borderBottom: "1px solid var(--color-border)",
      "& .MuiTreeItem-iconContainer": {
        marginRight: 0,
        width: 0
      },
      "& .MuiTreeItem-label": {
        paddingLeft: 0,
        // "& .MuiTypography-root": {
        //   fontWeight: `400 !important`,
        // },
      },
    },
    "& .MuiCollapse-root": {
      marginLeft: "0px",
      "& .MuiBox-root": {
        paddingLeft: "17px"
      }
    },
    "& .MuiCollapse-wrapperInner": {
      "& .MuiTreeItem-content": {
        borderBottom: "none",
        // marginBottom: "16px",
        "& .MuiTreeItem-label": {
          "& .MuiTypography-root": {
            fontWeight: `400 !important`,
          },
        },
      },
    },
  },
  tabs: {
    "&.MuiTabs-root": {
      minHeight: "20px",
      "& .Mui-selected": {
        fontWeight: "700 !important",
      },
    },
    "& .MuiButtonBase-root": {
      padding: "8px 16px !important",
      fontSize: `${pxToRem(16)} !important`,
      minHeight: "20px",
      color: `${palette.primary.light} !important`,
      fontWeight: "400 !important",
    },
  },
}));
const bfsSearch = (graph, key, targetId) => {
  const queue = [...graph];

  while (queue.length > 0) {
    const currNode = queue.shift();
    if (currNode._id === targetId) {
      return currNode;
    }
    if (currNode[key]) {
      queue.push(...currNode[key]);
    }
  }
  return []; // Target node not found
};
interface ShareSocialReport {
  shareModalOpen: boolean;
  handleShareModalOpen: (val: boolean) => void;
  getAllContacts: () => void;
}

const ShareSocialReportModal = (props: ShareSocialReport) => {
  const classes = useStyles();
  const [sendStatus, setsendStatus] = useState("INSTANT");
  const [weekCount, setWeekCount] = useState(1);
  const [sendFrequency, setSendFrequence] = useState("WEEK");
  const [editRecord, setEditRecord] = useState(null);
  const [dayToSend, setdayToSend] = useState(null);
  const [sendTimeHour, setsendTimeHour] = useState("00");
  const [sendTimeMinute, setsendTimeMinute] = useState("00");
  const [showSnakbar, setShowSnakbar] = useState(false);
  const [showSuccessMessage, setSuccessMessage] = useState(null);
  const [snakbarMsg, setSnakbarMsg] = useState("");
  const [step, setStep] = useState(1);
  const [seelctedVal, setSelectedVal] = useState("LAST_SEVEN_DAYS");
  const [msgType, setMsgType] = useState("");
  const [showLoadingBtn, setShowLoadingBtn] = useState(false);
  const [isSideModalVisible, setSideModalVisible] = useState(false);
  const [isSelectedFocus, setSelectedFocus] = useState(null);
  const { state: outcomeState, dispatch: UserTypeDispatch } =
    useContext(UserTypeContext);
  const { state: ITrackerState, dispatch: trackingDispatch } =
    useContext(TrackingContext);
  const { dispatch: reportTypeDispatch } =
    useContext(ReportsTypeContext);
  const [visibleAddContactModal, setVisibleAddContactModal] = useState(false);
  const [visibleManageContactModal, setVisibleManageContactModal] =
    useState(false);
  const { state: IContactTypeState, dispatch: contactsDispatch } =
    useContext(ContactsContext);
  const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
  const [selectedNodes, setSelectedNodes] = useState([]);
  const [selectedOutInflu, setSelectedOutInflu] = useState([]);
  const [viewSceduleReports, viewSocialReports] = useState(false);
  const [isInPreviewMode, setIsInPreviewMode] = useState(false);
  const allContacts = [
    {
      _id: "all",
      groupName: "All",
      contacts: [
        ...(IContactTypeState?.allContacts || []).map((it) => {
          if (it) {
            it.parent = "all";
          }
          return it;
        }),
      ],
    },
    ...IContactTypeState.groupContacts,
  ];
  useEffect(() => {
    if(props.shareModalOpen) {
      if(!outcomeState?.journeyCategoryList?.length ) {
        callservice()
      }
      if(!outcomeState?.outcomeList?.length) {
        getOutcomeList();
      }
      if(!outcomeState?.influenceList?.length) {
        getInfluenceList();
      }
      if(!outcomeState?.reflectiveList?.length) {
        getReflectiveList();
      }
    }
    return () => handleResetModal()
  }, [props.shareModalOpen])
  const getOutcomeList = () => {
    outcomeService
      .getOutcomeList(outcomeState.token)
      .then((data: OutcomeGetResponse) => {
        console.log("getOutcomeList data", data);
        
        UserTypeDispatch(addOutcomeAction(data?.data));
      })
      .catch((error) => {
        console.log("Outcome Error");
      });
  };
  const getInfluenceList = () => {
    influenceService
      .getInfluenceList(outcomeState.token)
      .then((data: InfluenceGetResponse) => {
        UserTypeDispatch(addInfluenceAction(data?.data));
      })
      .catch((error) => {
        console.log("influence Error");
      });
  };
  const getReflectiveList = () => {
    reflectiveQueService
      .getReflectiveList(outcomeState.token)
      .then((data: RefelectiveGetResponse) => {
        UserTypeDispatch(addRefelectiveAction(data?.data));
      })
      .catch((error) => {
        console.log("Ques error");
      });
  };
  const getPeronsltrackData = async (bodyData) => {
    let data = await trackingService.getPersonalJourneyList(
      outcomeState.token,
      bodyData
    );
    if (data.data.length <= 0) {
      UserTypeDispatch(isEmptyState(true));
    } else {
      UserTypeDispatch(isEmptyState(false));
    }

    UserTypeDispatch(addCategoryJourneyAction(data?.data));
    UserTypeDispatch(addNotesJourneyAction(data?.data));
    const newArr = [...outcomeState?.journeyCategoryExpandList];
    for (let index = 0; index < data?.data.length; index++) {
      const element = data?.data[index];
      newArr.push(element.categoryId);
    }
    // if (!IUserTypeState?.isPersonal) {
    newArr.push("outcome", "influence", "reflective");
    // }
    UserTypeDispatch(addCategoryExpandAction(newArr));
  };
  const callservice = async (showLoader = true) => {
    try {
      let startDay = moment().startOf("month");
      let endDate = moment().endOf("month");
      let registeredDate = moment(outcomeState.userDetails.createdAt);
      const current = moment();
      if (outcomeState.userDetails.createdAt) {
        const endOfMonth = moment().clone().endOf("month");
        if (endOfMonth?.diff(moment(), "day") >= 7) {
          endDate = moment().clone().endOf("month");
          // props?.setEndDate(moment().clone().endOf('month'))
        } else {
          const currDate = moment(startDay)?.clone().isBefore(registeredDate);
          if (currDate) {
            if (endOfMonth?.diff(registeredDate.clone(), "day") <= 7) {
              endDate = moment().clone().add(1, "month").endOf("month");
            } else {
              if (endOfMonth?.diff(registeredDate.clone(), "day") <= 15) {
                endDate = moment().clone().add(1, "month").endOf("month");
              } else {
                endDate = moment().clone().add(7, "day");
              }
              // endDate = moment().clone().add(7, 'day');
            }
          } else {
            if (endOfMonth?.diff(registeredDate.clone(), "day") <= 15) {
              endDate = moment().clone().add(1, "month").endOf("month");
            } else {
              endDate = moment().clone().add(7, "day");
            }
          }
        }
      }
      const bodyData = {
        from: moment(startDay).format("MM-DD-YYYY"),
        to: moment(endDate).format("MM-DD-YYYY"),
      };
      trackingDispatch(
        setTrackingState({
          showLoader: showLoader,
        })
      );
      let data = await trackingService.getJourneyList(
        outcomeState.token,
        bodyData
      );
      console.log("data", data);
      UserTypeDispatch(addJourneyAction(data));
      UserTypeDispatch(addNotesAction(data));
      // const newArr = [
      //   ...outcomeState?.journeyCategoryExpandList,
      //   "outcome",
      //   "influence",
      //   "reflective",
      // ];
      // UserTypeDispatch(addCategoryExpandAction(newArr));
      await getPeronsltrackData(bodyData);

      localStorage.removeItem("personalDataLoaded");
      setTimeout(() => {
        // currentDateRef && currentDateRef.current && currentDateRef.current.scrollIntoView()
      }, 500);
    } catch (error) {
      trackingDispatch(
        setTrackingState({
          showLoader: false,
        })
      );
    }
  };
  const handleResetModal = () => {
    setSideModalVisible(false)
    setIsInPreviewMode(false)
    viewSocialReports(false)
    setSelectedVal("LAST_SEVEN_DAYS")
    setSelectedNodes([])
    setSelectedOutInflu([])
    setSelectedFocus(null)
  }
  const allDefaultStates = [
    {
      _id: "Outcomes",
      groupName: "Outcomes",
      items: (outcomeState.outcomeList || []).map(
        (
          it: (OutcomeGetList & {
            parent: string;
          })
        ) => {
          if (it) {
            it.parent = "Outcomes";
          }
          return it;
        }
      ),
    },
    {
      _id: "Influences",
      groupName: "Influences",
      items: (outcomeState.influenceList || []).map(
        (
          it: (InfluenceGetList & {
            parent: string;
          })
        ) => {
          if (it) {
            it.parent = "Influences";
          }
          return it;
        }
      ),
    },
  ];
  const allPersonalStates = [];
  if (
    outcomeState?.journeyCategoryList &&
    outcomeState?.journeyCategoryList.length
  ) {
    for (
      let index = 0;
      index < outcomeState?.journeyCategoryList.length;
      index++
    ) {
      const element = outcomeState?.journeyCategoryList[index];
      if (element.name !== "Other") {
        const alls = [...element.alls].filter(
          (it) => it.influenceId || it.outcomeId
        );
        allPersonalStates.push({
          _id: element.name,
          groupName: element.name,
          items: [
            ...(alls || []).map(
              (
                it: OutcomeGetList & {
                  parent: string;
                }
              ) => {
                if (it) {
                  it.parent = element.name;
                }
                return it;
              }
            ),
          ],
        });
      } else {
        allPersonalStates.push({
          _id: element.name,
          groupName: element.name,
          items: [
            ...(element.outcomes || []).map(
              (
                it: OutcomeGetList & {
                  parent: string;
                }
              ) => {
                if (it) {
                  it.parent = element.name;
                }
                return it;
              }
            ),
            ...(element.influences || []).map(
              (
                it: OutcomeGetList & {
                  parent: string;
                }
              ) => {
                if (it) {
                  it.parent = element.name;
                }
                return it;
              }
            ),
          ],
        });
      }
    }
  }

  function getAllIds(node, key, idList = []) {
    idList.push(node._id);
    if (node[key]) {
      node[key].forEach((child) => getAllIds(child, key, idList));
    }
    return idList;
  }
  // Get IDs of all children from specific node
  const getAllChild = (array, key, id) => {
    return getAllIds(bfsSearch(array, key, id), key);
  };

  // Get all father IDs from specific node
  const getAllFathers = (id, array, key, list = []) => {
    const node = bfsSearch(array, key, id);
    if (node.parent) {
      list.push(node.parent);

      return getAllFathers(node.parent, array, key, list);
    }

    return list;
  };

  function isAllChildrenChecked(selectedArray, array, key, node, list) {
    const allChild = getAllChild(array, key, node._id);
    const nodeIdIndex = allChild.indexOf(node._id);
    allChild.splice(nodeIdIndex, 1);

    return allChild.every((nodeId) =>
      selectedArray.concat(list).includes(nodeId)
    );
  }

  const handleNodeSelect = (event, nodeId) => {
    event.stopPropagation();
    const allChild = getAllChild(allContacts, "contacts", nodeId);
    const fathers = getAllFathers(nodeId, allContacts, "contacts");

    if (selectedNodes.includes(nodeId)) {
      // Need to de-check
      setSelectedNodes((prevSelectedNodes) =>
        prevSelectedNodes.filter((id) => !allChild.concat(fathers).includes(id))
      );
    } else {
      // Need to check
      const ToBeChecked = allChild;
      for (let i = 0; i < fathers.length; ++i) {
        if (
          isAllChildrenChecked(
            selectedNodes,
            allContacts,
            "contacts",
            bfsSearch(allContacts, "contacts", fathers[i]),
            ToBeChecked
          )
        ) {
          ToBeChecked.push(fathers[i]);
        }
      }
      setSelectedNodes((prevSelectedNodes) =>
        [...prevSelectedNodes].concat(ToBeChecked)
      );
    }
  };
  const handleOutInfluSelect = (event, nodeId, isPersonal) => {
    event.stopPropagation();
    const allChild = getAllChild(
      isPersonal ? allPersonalStates : allDefaultStates,
      "items",
      nodeId
    );
    const fathers = getAllFathers(
      nodeId,
      isPersonal ? allPersonalStates : allDefaultStates,
      "items"
    );
    if (selectedOutInflu.includes(nodeId)) {
      // Need to de-check
      setSelectedOutInflu((prevSelectedNodes) =>
        prevSelectedNodes.filter((id) => !allChild.concat(fathers).includes(id))
      );
    } else {
      // Need to check
      const ToBeChecked = allChild;
      for (let i = 0; i < fathers.length; ++i) {
        if (
          isAllChildrenChecked(
            selectedOutInflu,
            isPersonal ? allPersonalStates : allDefaultStates,
            "items",
            bfsSearch(
              isPersonal ? allPersonalStates : allDefaultStates,
              "items",
              fathers[i]
            ),
            ToBeChecked
          )
        ) {
          ToBeChecked.push(fathers[i]);
        }
      }
      setSelectedOutInflu((prevSelectedNodes) =>
        [...prevSelectedNodes].concat(ToBeChecked)
      );
    }
  };
  const getContactsFromIds = () => {
    const contactsArr = [
      ...[...IContactTypeState?.allContacts].filter((it) =>
        selectedNodes.includes(it._id)
      ),
    ];
    for (
      let index = 0;
      index < IContactTypeState.groupContacts.length;
      index++
    ) {
      const element = IContactTypeState.groupContacts[index];
      if (element.contacts && element.contacts.length) {
        contactsArr.push(
          ...element.contacts.filter((it) => selectedNodes.includes(it._id))
        );
      }
    }
    return contactsArr;
  };
  const shareReport = () => {
    console.log("allDefaultStates[0].items", (allDefaultStates[0].items &&
      Array.isArray(allDefaultStates[0].items) &&
      allDefaultStates[0].items.length > 0) || 
      (allDefaultStates[1].items &&
      Array.isArray(allDefaultStates[1].items) &&
      allDefaultStates[1].items.length > 0));
    
    setShowLoadingBtn(true);
    if (
      (allDefaultStates[0].items &&
      Array.isArray(allDefaultStates[0].items) &&
      allDefaultStates[0].items.length > 0) || 
      (allDefaultStates[1].items &&
      Array.isArray(allDefaultStates[1].items) &&
      allDefaultStates[1].items.length > 0)
    ) {
      const objToSent = {
        // from: moment()
        //   .subtract(1, "week")
        //   .startOf("week")
        //   .add(1, "day")
        //   .format("MM-DD-YYYY"),
        // to: moment()
        //   .subtract(1, "week")
        //   .endOf("week")
        //   .add(1, "day")
        //   .format("MM-DD-YYYY"),
        contacts: getContactsFromIds(),
        baseUrl: window.location.origin + "/report-view",
        // weekNo: moment().subtract(1, "week").week(),
        outcomeIds: (allDefaultStates[0]?.items as any)
          ?.filter(
            (
              it: OutcomeGetList & {
                parent: string;
              }
            ) => selectedOutInflu.includes(it._id)
          )
          .map(
            (
              it: OutcomeGetList & {
                parent: string;
              }
            ) => it.outcomeId
          ),
        influenceIds: (allDefaultStates[1]?.items as any)
          .filter((it) => selectedOutInflu.includes(it._id))
          .map(
            (
              it: InfluenceGetList & {
                parent: string;
              }
            ) => it?.influenceId
          ),
        sendStatus: ["REGULARLY_MONTH", "REGULARLY_WEEK"].includes(sendStatus) ? "REGULARLY" : sendStatus,
        dayToSend: dayToSend,
        dateToSend: dayToSend,
        scheduleType: ["INSTANT"].includes(sendStatus) ? "LAST_WEEK" : seelctedVal,
        timeToSend: moment()
          .set({
            hour: sendTimeHour ? Number(sendTimeHour || 0) : 0,
            minute: sendTimeMinute ? Number(sendTimeMinute || 0) : 0,
            second: 0,
          })
          .utc()
          .format(),
        shareReportId: null,
        // weekCount: weekCount,
      };
      if (sendStatus === "REGULARLY_MONTH") {
        objToSent.dateToSend = dayToSend
        delete objToSent.dayToSend
      }
      if (sendStatus === "REGULARLY_WEEK") {
        objToSent.dayToSend = dayToSend
        delete objToSent.dateToSend
      }
      if (["INSTANT"].includes(sendStatus)) {
        delete objToSent.dateToSend
        delete objToSent.dayToSend
      }
      if (editRecord && editRecord.shareReportId) {
        objToSent.shareReportId = editRecord.shareReportId;
      }
      contactsService
        .shareReport(objToSent, outcomeState.token)
        .then((data) => {
          setSuccessMessage(
            editRecord && editRecord.shareReportId
              ? sendStatus === "STOP"
                ? "Social report paused"
                : "Social report scheduled"
              : ["REGULARLY", "STOP"].includes(sendStatus)
                ? "Social report scheduled"
                : "Social report sent"
          );
          setEditRecord(null);
          navigator.clipboard.writeText(data.body.url);
          setShowSnakbar(true);
          setMsgType("success");
          props?.handleShareModalOpen(false)
          setEditRecord(null)
          setEditRecord(null)
          // setSnakbarMsg(data?.description);
          setSnakbarMsg("Successfully shared the report");
          setTimeout(() => {
            setShowSnakbar(false);
          }, 3000);
          handleResetModal()
        
        })
        .catch((err) => {
          if (err?.description) {
            setShowSnakbar(true);
            setMsgType("error");
            setSnakbarMsg(err?.description);
          }
        })
        .finally(() => {
          setShowLoadingBtn(false);
        });
    }
  };
  const handleAddContact = (values) => {
    setShowLoadingBtn(true);
    const foundObject = [...IContactTypeState?.allContacts].find(
      (it) => it.email === values.email
    );

    if (foundObject) {
      setShowLoadingBtn(false);
      setShowSnakbar(true);
      setMsgType("error");
      setSnakbarMsg("Contact is already added");
      return;
    }
    contactsService
      .createUpdateContact(values, outcomeState.token)
      .then((data) => {
        setVisibleAddContactModal(false);
        props.getAllContacts();
        setShowSnakbar(true);
        setMsgType("success");
        setSnakbarMsg(data?.description);
      })
      .catch((err) => {
        if (err?.description) {
          setShowSnakbar(true);
          setMsgType("error");
          setSnakbarMsg(err?.description);
        }
      })
      .finally(() => {
        setShowLoadingBtn(false);
      });
  };

  useEffect(() => {
    if (editRecord && editRecord.shareReportId) {
      setSelectedNodes(editRecord.contacts.map((it) => it._id));
      const infrluOuArr = [];
      if (editRecord.influenceData && editRecord.influenceData.length > 0) {
        infrluOuArr.push(...editRecord.influenceData.map((it) => it._id));
      }
      if (editRecord.outcomeData && editRecord.outcomeData.length > 0) {
        infrluOuArr.push(...editRecord.outcomeData.map((it) => it._id));
      }
      setSelectedOutInflu(infrluOuArr);
      const isMonthly = ["LAST_THIRTY_DAYS", "LAST_MONTH"].includes(editRecord.scheduleType)
      const isWeekly = ["LAST_SEVEN_DAYS", "LAST_WEEK"].includes(editRecord.scheduleType)
      if (isMonthly) {
        setsendStatus("REGULARLY_MONTH")
        setSelectedVal(editRecord.scheduleType)
        setdayToSend(editRecord.dateToSend)
      } else if (isWeekly) {
        setsendStatus("REGULARLY_WEEK")
        setSelectedVal(editRecord.scheduleType)
        setdayToSend(editRecord.dayToSend)
      } else {
        setsendStatus(editRecord.sendStatus);
        setdayToSend(editRecord.dayToSend);
      }
      setWeekCount(editRecord.weekCount);
      setSendFrequence("WEEK");
      setsendTimeHour(moment(editRecord.timeToSend).format("h"));
      setsendTimeMinute(moment(editRecord.timeToSend).format("mm"));
      //     const [selectedNodes, setSelectedNodes] = useState([]);
      // const [selectedOutInflu, setSelectedOutInflu] = useState([]);
      // const [viewSceduleReports, viewSocialReports] = useState(false);
    } else {
      setSelectedNodes([]);
      setSelectedOutInflu([]);
      setsendStatus("INSTANT");
      setWeekCount(1);
      setSendFrequence("WEEK");
      setdayToSend(null);
      setsendTimeHour("00");
      setsendTimeMinute("00");
    }
  }, [editRecord]);

  const viewShareReport = () => {
    let userValues = JSON.parse(localStorage.getItem("userValues"));
    console.log("allDefaultStates[0].items", allDefaultStates[0].items, sendStatus, seelctedVal);
    if (allDefaultStates[0].items || allDefaultStates[1].items) {
      const obj = {
        from: moment()
          .subtract(1, "week")
          .startOf("week")
          .add(1, "day")
          .format("MM-DD-YYYY"),
        to: moment()
          .subtract(1, "week")
          .endOf("week")
          .add(1, "day")
          .format("MM-DD-YYYY"),
        uid: outcomeState?.userId ? outcomeState?.userId : userValues?.uid,
        outcomeIds: (allDefaultStates[0].items as any)
          .filter((it) => selectedOutInflu.includes(it._id))
          .map((it: any) => it.outcomeId),
        influenceIds: (allDefaultStates[1].items as any)
          .filter((it) => selectedOutInflu.includes(it._id))
          .map((it: any) => it.influenceId),
      };
      if (["REGULARLY_MONTH"].includes(sendStatus)) {
        if (["LAST_THIRTY_DAYS"].includes(seelctedVal)) {
          obj.from = moment()
            .subtract(30, "day")
            .format("MM-DD-YYYY")
          obj.to = moment()
            .subtract(1, "day")
            .format("MM-DD-YYYY")
        }
        if (["LAST_MONTH"].includes(seelctedVal)) {
          obj.from = moment()
            .subtract(1, "month")
            .startOf('month')
            .format("MM-DD-YYYY")
          obj.to = moment()
            .subtract(1, "month")
            .endOf('month')
            .format("MM-DD-YYYY")
        }
      }
      if (["REGULARLY_WEEK"].includes(sendStatus)) {
        if (["LAST_SEVEN_DAYS"].includes(seelctedVal)) {
          obj.from = moment()
            .subtract(7, "day")
            .format("MM-DD-YYYY")
          obj.to = moment()
            .subtract(1, "day")
            .format("MM-DD-YYYY")
        }
        if (["LAST_WEEK"].includes(seelctedVal)) {
          obj.from = moment()
            .subtract(1, "week")
            .startOf("week")
            .add(1, "day")
            .format("MM-DD-YYYY")
          obj.to = moment()
            .subtract(1, "week")
            .endOf("week")
            .add(1, "day")
            .format("MM-DD-YYYY")
        }
      }
      contactsService
        .viewshareReport(obj)
        .then((data) => {
          reportTypeDispatch(setSelectedRow({ ...obj, till: obj.to }));
          reportTypeDispatch(setSelectedRowDetails({ ...data, ...obj }));
          // setShowSnakbar(true);
          // setMsgType("success");
          // setSnakbarMsg(data?.description);
        })
        .catch((err) => {
          if (err?.description) {
            //   setShowSnakbar(true);
            //   setMsgType("error");
            //   setSnakbarMsg(err?.description);
          }
        })
        .finally(() => {
          // setShowLoadingBtn(false)
        });
    }

  }
  return (
    <Grid>
      <SnackBarCompV2
        showSnakbar={showSnakbar}
        handleCloseSnakbar={() => {
          setShowSnakbar(false);
        }}
        
        snakbarMsg={<CommonTypo size={16} fontWeight={600} lineHeight={19.2} color="var(--color-text-primary)">{snakbarMsg}</CommonTypo>}
        type={msgType ? msgType : "success"}
        alertSx={{
          background: "var(--color-new-main)",
          boxShadow: "0px 4px 8px 0px #0000001A",
          padding: "16px",
          borderRadius: "12px",
          height: "52px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          "& .MuiAlert-icon": {
            marginRight: "0px"
          }
        }}
        icon={msgType === "success" ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.7883 7.46172C13.8757 7.54882 13.945 7.65231 13.9923 7.76626C14.0397 7.88022 14.064 8.00239 14.064 8.12578C14.064 8.24917 14.0397 8.37134 13.9923 8.4853C13.945 8.59925 13.8757 8.70275 13.7883 8.78984L9.41328 13.1648C9.32619 13.2522 9.22269 13.3216 9.10874 13.3689C8.99478 13.4162 8.87261 13.4406 8.74922 13.4406C8.62583 13.4406 8.50366 13.4162 8.3897 13.3689C8.27575 13.3216 8.17226 13.2522 8.08516 13.1648L6.21016 11.2898C6.12295 11.2026 6.05378 11.0991 6.00658 10.9852C5.95939 10.8712 5.9351 10.7491 5.9351 10.6258C5.9351 10.5025 5.95939 10.3803 6.00658 10.2664C6.05378 10.1525 6.12295 10.0489 6.21016 9.96172C6.29737 9.87451 6.40089 9.80534 6.51483 9.75814C6.62877 9.71095 6.75089 9.68666 6.87422 9.68666C6.99755 9.68666 7.11967 9.71095 7.23361 9.75814C7.34755 9.80534 7.45108 9.87451 7.53828 9.96172L8.75 11.1719L12.4617 7.45938C12.5489 7.37236 12.6525 7.3034 12.7664 7.25642C12.8803 7.20944 13.0023 7.18537 13.1255 7.18559C13.2487 7.18581 13.3706 7.21031 13.4844 7.25769C13.5981 7.30507 13.7014 7.3744 13.7883 7.46172ZM18.4375 10C18.4375 11.6688 17.9427 13.3001 17.0155 14.6876C16.0884 16.0752 14.7706 17.1566 13.2289 17.7952C11.6871 18.4338 9.99064 18.6009 8.35393 18.2754C6.71721 17.9498 5.2138 17.1462 4.03379 15.9662C2.85379 14.7862 2.05019 13.2828 1.72463 11.6461C1.39907 10.0094 1.56616 8.31286 2.20477 6.77111C2.84338 5.22936 3.92484 3.9116 5.31238 2.98448C6.69992 2.05735 8.33122 1.5625 10 1.5625C12.237 1.56498 14.3817 2.45473 15.9635 4.03653C17.5453 5.61833 18.435 7.763 18.4375 10ZM16.5625 10C16.5625 8.70206 16.1776 7.43327 15.4565 6.35407C14.7354 5.27487 13.7105 4.43374 12.5114 3.93704C11.3122 3.44034 9.99272 3.31038 8.71972 3.5636C7.44672 3.81681 6.2774 4.44183 5.35962 5.35961C4.44183 6.27739 3.81682 7.44672 3.5636 8.71972C3.31038 9.99272 3.44034 11.3122 3.93704 12.5114C4.43374 13.7105 5.27488 14.7354 6.35407 15.4565C7.43327 16.1776 8.70206 16.5625 10 16.5625C11.7399 16.5606 13.408 15.8686 14.6383 14.6383C15.8686 13.408 16.5606 11.7399 16.5625 10Z" fill="#3E4240" />
        </svg> : null
        }
      />
      <Dialog
        onClose={() => {
          handleResetModal()
          props.handleShareModalOpen(false)
         
        }}
        open={props.shareModalOpen}
        className="dialogWrapper dialogWrapper-share dialogWrapper-mobileScreen"
        sx={{
          ".MuiPaper-root": {
            minHeight: viewSceduleReports ? "200px" :"514px",
            minWidth: "360px",
            padding: isSideModalVisible ? "0px !important" : "32px 24px !important",
            borderRadius: "12px",
            display: "flex",
            gap: "16px",
            height: isSideModalVisible ? "100%" : "auto",
            flexDirection: isSideModalVisible ? "row" : "column"
          },
        }}
      >
        {!isSideModalVisible && (
          <Box display={"flex"} alignItems={"flex-end"} alignSelf={"stretch"} justifyContent={"flex-end"}>
            <CloseButton onClick={() => {
              handleResetModal()
              props.handleShareModalOpen(false)
              reportTypeDispatch(setSelectedRow({}));
              reportTypeDispatch(setSelectedRowDetails({}));
            }} />
          </Box>
        )}

        {!viewSceduleReports && <SocialReportShareStep1
          setSideModalVisible={setSideModalVisible}
          setSelectedFocus={setSelectedFocus}
          isSideModalVisible={isSideModalVisible}
          isSelectedFocus={isSelectedFocus}
          selectedNodes={selectedNodes}
          selectedOutInflu={selectedOutInflu}
          allContacts={allContacts}
          editRecord={editRecord}
          shareReport={shareReport}
          allDefaultStates={allDefaultStates}
          viewSchedule={() => {
            viewSocialReports(!viewSceduleReports);
            setSuccessMessage(null);
            setEditRecord(null);
          }}
          viewShareReport={viewShareReport}
          dayToSend={dayToSend}
          seelctedVal={seelctedVal}
          sendStatus={sendStatus}
          isInPreviewMode={isInPreviewMode} setIsInPreviewMode={setIsInPreviewMode} isDarkMode={isDarkMode}
        />}
        {viewSceduleReports && <SocialScheduleReport
          setSideModalVisible={setSideModalVisible}
          setSelectedFocus={setSelectedFocus}
          isSideModalVisible={isSideModalVisible}
          isSelectedFocus={isSelectedFocus}
          selectedNodes={selectedNodes}
          allContacts={allContacts}
          viewSchedule={() => {
            viewSocialReports(!viewSceduleReports);
            setSuccessMessage(null);
            setEditRecord(null);
          }}
          allDefaultStates={allDefaultStates}
          viewSceduleReports={viewSceduleReports}
          viewSocialReports={viewSocialReports}
          classes={classes}
          editRecord={editRecord}
          setEditRecord={setEditRecord}
          setShowSnakbar={setShowSnakbar}
          setSnakbarMsg={setSnakbarMsg}
          setMsgType={setMsgType}
        />}
        {isSideModalVisible && !isInPreviewMode && (
          <SocialReportShareStep1Content
            setSideModalVisible={setSideModalVisible}
            setSelectedFocus={setSelectedFocus}
            isSideModalVisible={isSideModalVisible}
            isSelectedFocus={isSelectedFocus}
            setVisibleAddContactModal={setVisibleAddContactModal}
            classes={classes}
            allDefaultStates={allDefaultStates}
            seelctedVal={seelctedVal} setSelectedVal={setSelectedVal}
            handleOutInfluSelect={handleOutInfluSelect}
            dayToSend={dayToSend} setdayToSend={setdayToSend}
            selectedOutInflu={selectedOutInflu}
            radioValue={sendStatus}
            setRadioValue={setsendStatus}
            allPersonalStates={allPersonalStates}
            setVisibleManageContactModal={setVisibleManageContactModal}
            selectedNodes={selectedNodes}
            handleNodeSelect={handleNodeSelect}
            allContacts={allContacts}
            onClose={() => {
              handleResetModal()
              props.handleShareModalOpen(false)
              reportTypeDispatch(setSelectedRow({}));
              reportTypeDispatch(setSelectedRowDetails({}));
            }}
            editRecord={editRecord}
            isDarkMode={isDarkMode}
          />
        )}
        {isSideModalVisible && isInPreviewMode && (
          <SocialReportStepsSidePreview
            setSideModalVisible={setSideModalVisible}
            setSelectedFocus={setSelectedFocus}
            isSideModalVisible={isSideModalVisible}
            isSelectedFocus={isSelectedFocus}
            setVisibleAddContactModal={setVisibleAddContactModal}
            classes={classes}
            allDefaultStates={allDefaultStates}
            seelctedVal={seelctedVal} setSelectedVal={setSelectedVal}
            handleOutInfluSelect={handleOutInfluSelect}
            dayToSend={dayToSend} setdayToSend={setdayToSend}
            selectedOutInflu={selectedOutInflu}
            radioValue={sendStatus}
            setRadioValue={setsendStatus}
            allPersonalStates={allPersonalStates}
            setVisibleManageContactModal={setVisibleManageContactModal}
            selectedNodes={selectedNodes}
            handleNodeSelect={handleNodeSelect}
            allContacts={allContacts}
            onClose={() => {
              handleResetModal()
              props.handleShareModalOpen(false)
              reportTypeDispatch(setSelectedRow({}));
              reportTypeDispatch(setSelectedRowDetails({}));
            }}
          />
        )}

        {visibleAddContactModal && (
          <AddContactModal
            visibleAddContactModal={visibleAddContactModal}
            setVisibleAddContactModal={setVisibleAddContactModal}
            handleAddContact={handleAddContact}
            showLoadingBtn={showLoadingBtn}
            setShowLoadingBtn={setShowLoadingBtn}
          />
        )}
        {visibleManageContactModal && (
          <ManageContactModal
            visibleManageContactModal={visibleManageContactModal}
            setVisibleManageContactModal={setVisibleManageContactModal}
            showLoadingBtn={showLoadingBtn}
            setShowLoadingBtn={setShowLoadingBtn}
            setShowSnakbar={setShowSnakbar}
            setMsgType={setMsgType}
            setSnakbarMsg={setSnakbarMsg}
            getAllContacts={props.getAllContacts}
          />
        )}
      </Dialog>
    </Grid>
  );
};
export default ShareSocialReportModal;
